import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import { MgtfeForm } from '@app/models/form/mgtfe-form.model';
import { MgtfeFormService } from '@app/services/mgtfe-form.service';
import { tap } from 'rxjs/operators';
import { Session } from '@app/app.session';
import { makeCurrentAcademicYear } from '@app/shared/util/academic-year.utils';

export class MgtfeFormStateModel {
  current: MgtfeForm;
  search: MgtfeForm[];
  criteria: {[index: string]: any}
}

export class InitMgtfe {
  static readonly type = '[mgtfe] initMgtfe';
}

export class SubmitMgtfe{
  static readonly type = '[mgtfe] SubmitMgtfe';
  constructor (public mgtfe: MgtfeForm) {}
}

export class SaveMgtfe {
  static readonly type = '[mgtfe] SaveMgtfe';
  constructor (public mgtfe: MgtfeForm) {}
}

export class ValidateMgtfe {
  static readonly type = '[mgtfe] ValidateMgtfe';
  constructor (public mgtfe: MgtfeForm) {}
}


export class GetMgtfe{
  static readonly type = '[mgtfe] getMgtfe';
  constructor (public id: number) {}
}

export class SearchMgtfe{
  static readonly type = '[mgtfe] SearchMgtfe';
  constructor (public idUser: number, public criteria?: any) {}
}

@State<MgtfeFormStateModel>({
  name: 'mgtfe',
  defaults: {
    current: new MgtfeForm(),
    search: [],
    criteria: {}
  }
})
export class MgtfeFormState implements NgxsOnInit {

  constructor(private mgtfeFormService:MgtfeFormService, private session:Session) {
    MgtfeFormState.mgtfeFormService = mgtfeFormService;
  }

  ngxsOnInit(ctx?: StateContext<MgtfeFormStateModel>): void {
    ctx.patchState({
      criteria: {
        university: null,
        academicYear: 'any',
        treated: false
      }
    })
  }

  private static mgtfeFormService: MgtfeFormService;

  @Selector()
  static current(state: MgtfeFormStateModel) {
    return state.current;
  }

  @Selector()
  static search(state: MgtfeFormStateModel) {
    return state.search;
  }

  @Selector()
  static criteria(state: MgtfeFormStateModel) {
    return state.criteria;
  }

  @Action(InitMgtfe)
  init(ctx: StateContext<MgtfeFormStateModel>) {
    let mgtfeForm = new MgtfeForm();
    mgtfeForm.researcher = {id: this.session.user.id};
    ctx.patchState({current: mgtfeForm});
  }

  @Action(SaveMgtfe)
  save(ctx: StateContext<MgtfeFormStateModel>, action: SaveMgtfe) {
    return this.mgtfeFormService.save(action.mgtfe).pipe(
      tap(mgtfe => ctx.patchState({current: mgtfe}))
    );
  }

  @Action(SubmitMgtfe)
  submit(ctx: StateContext<MgtfeFormStateModel>, action: SubmitMgtfe) {
    return this.mgtfeFormService.submit(action.mgtfe).pipe(
      tap(mgtfe => ctx.patchState({current: mgtfe}))
    );
  }

  @Action(GetMgtfe)
  get(ctx: StateContext<MgtfeFormStateModel>, action: GetMgtfe) {
    return this.mgtfeFormService.get(action.id).pipe(
      tap(mgtfe => ctx.patchState({current: mgtfe}))
    );
  }

  @Action(ValidateMgtfe)
  validate(ctx: StateContext<MgtfeFormStateModel>, action: ValidateMgtfe) {
      ctx.patchState({current: action.mgtfe})
  }

  @Action(SearchMgtfe)
  search(ctx: StateContext<MgtfeFormStateModel>, action: SearchMgtfe) {
    if (action.criteria) {
      ctx.patchState({criteria: action.criteria});
    }
    return this.mgtfeFormService.searchForUser(action.idUser, { ...ctx.getState().criteria }).pipe(
      tap(mgtfes => ctx.patchState({search: mgtfes}))
    );
  }
}
